module.exports = __webpack_public_path__ + "images/income.cec87969be5b728c3e87cf730a87606e.svg";